<template>
    <div>
        <form-field v-model='model.phone' placeholder='Téléphone' :icon='phoneIcon' class="phone-field"/>
        <form-field v-model='model.password' placeholder='Mot de passe' :icon='passwordIcon' type="password" class="phone-field"/>
    </div>
</template>

<script>
import formField from './FormField'
export default {
    props: {
        value: {
            type: Object
        }
    },
    data: () => ({
        /* phone datas */
        model: {
            phone: '',
            password: ''
        },
        phoneIcon: require('../assets/phone.svg'),
        passwordIcon: require('../assets/password.svg')
    }),
    components: {
        formField
    },
    methods: {
        isvalid (){
            return this.model.phone && this.model.password != ''?true:false
        }
    },
    watch: {
        model: {
            handler: function (val) {
                this.$emit('input',val)
            },
            deep: true
        } 
        
    }
}
</script>

<style>

</style>
